import { createReducer } from 'redux-starter-kit';
import { translation } from '../../_helpers/Translate';
import { AttachChildApi } from './AttachChildApi';
import { handleError } from '../../utils/handleError';
import Notice from '../../utils/Notice';
import i18next from 'i18next';
import { DocumentApi } from '../../passport/PassportService';

export const attachChildDucksModule = 'attachChildDucks';
const LOADING = `${attachChildDucksModule}/LOADING`;
const SET_APPLICATIONS = `${attachChildDucksModule}/SET_APPLICATIONS`;
const CLEAR_STATE = `${attachChildDucksModule}/CLEAR_STATE`;

const initialState = {
  loading: false,
  data: [],
  pageNumber: 1,
  totalElements: 0
};

export const clearState = () => ({ type: CLEAR_STATE });

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.loading;
  },
  [SET_APPLICATIONS]: (state, action) => {
    state.data = action.data;
    state.pageNumber = action.pageNumber;
    state.totalElements =
      action.pageNumber === 1 ? action.totalElements : state.totalElements;
  },
  [CLEAR_STATE]: () => initialState
});

export const getAllRequests = filter => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const { data } = await AttachChildApi.loadRequests(JSON.stringify(filter));
    dispatch({
      type: SET_APPLICATIONS,
      data: data.result.content,
      pageNumber: data.pageNumber,
      totalElements: data.totalElements
    });
  } catch (er) {
    handleError(er, translation('attachChildDucks_loadRequesterFailed'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
export function downloadFile(value) {
  const download = data => {
    let element = document.createElement('a');
    document.body.appendChild(element);
    element.style.display = 'none';

    let blob = new Blob([data], { type: 'octet/stream' });
    let url = window.URL.createObjectURL(blob);
    element.href = url;
    element.download = value.documentName;
    element.click();
    window.URL.revokeObjectURL(url);
  };

  DocumentApi.download(value.documentLink, 1).then(response => {
    download(response.data);
  });
}

export const approveRequest = (id, filter, close) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const { data } = await AttachChildApi.approveRequest(id);
    if (data.status === 'SUCCESS') {
      Notice.success(i18next.t('attachChildDucks_approveSuccess'));
      close();
      dispatch(getAllRequests(filter));
    }
  } catch (er) {
    handleError(er, translation('attachChildDucks_approveFailed'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
export const declineRequest = (id, filter, close, comment) => async dispatch => {
  try {
    dispatch({ type: LOADING, loading: true });
    const { data } = await AttachChildApi.declineRequest(id, comment);
    if (data.status === 'SUCCESS') {
      Notice.success(i18next.t('attachChildDucks_declineSuccess'));
      close();
      dispatch(getAllRequests(filter));
    }
  } catch (er) {
    handleError(er, translation('attachChildDucks_declineFailed'));
  } finally {
    dispatch({ type: LOADING, loading: false });
  }
};
